import React from "react";
import R14, {
  View,
  StyleSheet,
  Image,
  Form,
  TextInputField,
  Dimensions,
  Platform,
} from "../core";
import Touchable from "./TouchableComponent";
import { commonStyles } from "../assets/css/commonStyle";
import { commonFontStyles } from "../assets/css/commonFontStyles";
import { customCommonStyles } from "../assets/css/customCommonStyle";
import { commonMetricsStyle } from "../assets/css/commonMetricsStyle";
import UserAgentValidator from "../utils/UserAgentValidator";
import searchIcon from "../assets/images/NewSearch.png";
import arrowForward from "../assets/images/back_icon.png";

export default R14.connect(
  class SearchDataTableComponent extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        isSearchOpen: false,
      };
    }

    async componentDidMount() {
      this.props.app.dm.notificationDomain.setState({
        isMobileDevice: UserAgentValidator.isMobileDevice(),
      });
    }

    searchToggle = async () => {
      this.setState({ isSearchOpen: !this.state.isSearchOpen });
      if(!!this.props.app.dm.userSession.state.leftMenuOverlay && this.props.app.dm.notificationDomain.state.isMobileDevice)
        this.props.app.dm.userSession.setState({
          leftMenuToggle: false,
          leftMenuOverlay: false,
        });
    };

    searchCloseToggle = () => {
      let form = this.props.app.ui.form("searchBill");
      if(this.props.searchText &&  form && form.elmts && form.elmts.searchText) {
        form.elmts.searchText.setValue("");
      }
      this.setState({ isSearchOpen: false });
    }

    onSearch = (val) => {
      this.props.app.dm.userSession.setState({ isLoading: true });
      this.props.getPageData({search: val})
      this.setState({ isSearchOpen: true });
    };

    renderSearchSection = () => {
      const {isSearchOpen} = this.state;
      let form = this.props.app.ui.form("searchBill");
      if(this.props.searchText &&  form && form.elmts && form.elmts.searchText) {
        form.elmts.searchText.setValue(this.props.searchText);
      }
      return (
        <View style={[styles.container, this.props.style]}>
          <View style={[styles.inner, isSearchOpen ? null : commonStyles.displayNone]}>
              <Form name="searchBill" style={[ commonStyles.flex0, commonStyles.paddingAll0]}>
                <View style={[styles.formContainer]}>
                  <TextInputField
                    name="searchText"
                    label=""
                    style={[styles.searchField, commonFontStyles.workSans, commonMetricsStyle.heading6, customCommonStyles.inputHeight,]}
                    labelTextStyle={[commonStyles.labelText, commonFontStyles.workSans, commonMetricsStyle.exSmallHeading]}
                    labelStyle={[commonStyles.formLabelStyle,customCommonStyles.inputLableStyle]}
                    autoFocus={false}
                    onChangeText={(val) => this.onSearch(val)}
                    helperTextStyle={[customCommonStyles.helperTextStylecustom, commonMetricsStyle.helperTextFontStyle, commonFontStyles.workSans, commonStyles.left0]}
                  />
                  <Touchable style={[styles.arrowIconWrap]} onPress={() => this.searchCloseToggle()}>
                    <View style={styles.arrowIconContainer}>
                      <Image source={arrowForward} style={[styles.backgroundImage, customCommonStyles.customBackgroundImageHideIcon]} />
                    </View>
                  </Touchable>
                </View>
              </Form>
            </View>
        </View>
      );
    };

    render() {
      if(!!this.props.app.dm.userSession.state.isUberDocs) return null;
      return (
        <>
          <Touchable onPress={this.searchToggle}>
            <View tooltip={'Search Bill'} style={[styles.marginLtRt8]}>
            <Image source={searchIcon} style={commonStyles.icon18} />
            </View>
          </Touchable>
          {this.renderSearchSection()}
        </>
      );
    }
  }
);
const screenWidth = Dimensions.get('window').width;

const styles = StyleSheet.create({
  marginLtRt8: {
    marginLeft: 8,
    marginRight: 16,
  },
  container: {
    // flex: 1,
    justifyContent: 'space-around',
    backgroundColor: "#fff",
    maxHeight: 34,
    position: "absolute",
    right: 10,
    width: screenWidth - 20,
    marginTop: -8,
    // right: 16,
    zIndex: 99999
  },

  inner: {
    flex: 1,
    minHeight: 34
  },

  formContainer: {
    width: "100%",
    position: "relative",
    marginBottom: 20,
  },
  searchField: {
    width: "100%",
    // display: "block",
    marginBottom: 0,
    top: -8
  },
  arrowIconWrap: {
    position: "absolute",
    height: 30,
    width: 30,
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
    top: Platform.OS === 'web' ? 10 : -6,
    marginRight: 16,
    right: 0,
    marginTop: 0,
    marginLeft: 0,
  },
  arrowIconContainer: {
    width: 48,
    height: 48,
    position: "absolute",
    top: 0,
    right: 2,
  },
  backgroundImage: {
    width: 16,
    height: 16,
    display: "block",
    backgroundSize: "cover",
    position: "relative",
    top: 5,
    right: -7,
  },
});
